module.exports = __webpack_public_path__ + "static/media/payment-arrangement-plan.4b4d5acc.png";